import React from "react";
import styled from "styled-components";
import { Button, StyledText } from "../../../../components/common";
import { useTheme } from "../../../../hooks";
import Smile from "../../../../components/images/congrats-img.png";
import Sad from "../../../../components/images/sad.png";
import { useHistory } from "react-router-dom";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 1000;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  height: 60%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 20px;
`;

const PointStatsModal = ({ onBackDropClick, onClose, isEligible, rank }) => {
  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  const goHome = () => {
    history.push("/home?token=" + JSON.parse(localStorage.getItem("token")));
  };

  const startSpinning = () => {
    history.push("/spin_the_wheel/home", { rank });
  };

  const eligibleMessage =
    "Congrats! You were ranked among the top participants during the point accumulation period and are now eligible to spin for exciting rewards!";
  const nonEligibleMessage =
    "Unfortunately, you didn’t earn enough points to be in the top participants during the point accumulation period, therefore you’re not eligible to spin. Stay active and aim for the top next time!";

  return (
    <>
      <ModalOverlay onClick={onBackDropClick} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div
          onClick={onBackDropClick}
          style={{
            width: 50,
            height: 8,
            backgroundColor: "#cbcbcb",
            borderRadius: 10,
          }}
        />

        <StyledText style={{ fontSize: 20, padding: "5px 0" }}>
          {isEligible ? "Congratulations!" : "Better Luck Next Time!"}
        </StyledText>

        <img
          src={isEligible ? Smile : Sad}
          style={{ width: "90px" }}
          alt="Status Icon"
        />
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            fontSize: "13px",
            margin: 0,
            padding: "4% 12%",
          }}
          color="#000"
        >
          {isEligible ? eligibleMessage : nonEligibleMessage}
        </StyledText>

        <ButtonContainer>
          <Button
            style={{
              backgroundColor: "#ffcc00",
              width: "100%",
            }}
            onClick={isEligible ? startSpinning : onClose}
          >
            <StyledText color="#333">{isEligible ? "Spin" : "Ok"}</StyledText>
          </Button>
        </ButtonContainer>
      </ModalContent>
    </>
  );
};

export default PointStatsModal;
